/**
 * @fileoverview Syndicator Showdown — Vite Entry Point
 *
 * Mounts the React application into the DOM.
 * Global styles are imported here so they apply to every page.
 *
 * StrictMode is enabled during development to surface potential issues.
 * It renders components twice in dev only — not in production builds.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

// ── Global stylesheets — order matters ────────────────────────────────
// 1. Design tokens (CSS custom properties) must load first
// 2. Base reset / body styles second
import './styles/tokens.css';
import './styles/theme.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);